import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PusherService } from './pusher.service';
import { environment } from '../../environments/environment';
import { tap, catchError } from 'rxjs/operators';
import { from, Subject , throwError } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConversationService {

    private convoSelectSource = new Subject<any>();
    private activeConversation = new BehaviorSubject<any>(null);
    private disableShorcutSource = new Subject<any>();
    private FiltershortcutSource = new BehaviorSubject<any[]>([]);
    private selectConversationsource = new Subject<number>();
    //Select option on right click menu
    private selectAction= new Subject();
    //Reply option on right click menu
    private replyAction = new Subject<boolean>();

    convoSelect$ = this.convoSelectSource.asObservable();
    ShortcutSource$ = this.disableShorcutSource.asObservable();
    FilterShortcut$=this.FiltershortcutSource.asObservable();
    activeConversation$ = this.activeConversation.asObservable();
    //Select option on right click menu
    selectAction$=this.selectAction.asObservable();
    //Reply option on right click menu
    replyAction$=this.replyAction.asObservable();
    

    selectConversation$ = this.selectConversationsource.asObservable();

    emitSelectAction(){
        this.selectAction.next();
    }

    emitReplyAction(Reply_selected:boolean):void{
        this.replyAction.next(Reply_selected);
    }

    emitActiveConversation(conversationId: number): void {
        this.selectConversationsource.next(conversationId);
    }

    setActiveConversation(conversation: any) {
        this.activeConversation.next(conversation);
      }
      getActiveConversation() {
        return this.activeConversation.getValue();
      }

    updateFilterShortcut(newFilter: any[]): void {
        this.FiltershortcutSource.next(newFilter);
      }

    GetFilterShortcut(): any[] {
        return this.FiltershortcutSource.getValue();
    }

    emitConvoSelect(event) {
        this.convoSelectSource.next(event);
      }

      emitdisableShortcut() {
        this.disableShorcutSource.next();
      }


    constructor(private http: HttpClient,public loading: LoadingService) {}
        //showing loading
        ShowLoading: boolean=false;

    updateQuickmessages(conversation: any): Observable<any> {
        // Pass the URL as the first argument and the conversation object as the second argument
        return this.http.post(`${environment.api_url}/conversation/quickmessages`, conversation);
    }

    searchAdvantageCustomers(payload: {
        first_name?: string;
        middle_name?: string;
        last_name?: string;
        company?: string;
        phone?: string;
        email?: string;
        address?: string;
        city?: string;
        province?: string;
        postal_code?: string;
        search_type?: string;
    }): Observable<any> {
        return this.http.post<any>(`${environment.api_url}/advantage/customers/search`, payload);
    }

    getAdvantageCustomerRecords(entityIdx: number, includeInactive: boolean = false): Observable<any> {
        let params = new HttpParams()
            .set('include_inactive', includeInactive ? '1' : '0');

        return this.http.get<any>(`${environment.api_url}/advantage/customer/${entityIdx}/records`, { params });
    }

    attachAdvantageToConversation(payload: {
        conversation_id: number;
        module: number;
        object_idx: number;
        number?: string;
        entity_idx?: number;
        phone?: string;
        email?: string;
        customer_type_id?: number;
    }): Observable<any> {
        return this.http.post<any>(`${environment.api_url}/advantage/attach`, payload);
    }

    createAdvantageCustomer(payload: {
        first_name?: string;
        middle_name?: string;
        last_name?: string;
        address?: string;
        city?: string;
        phone?: string;
        email?: string;
        province?: string;
        postal_code?: string;
    }): Observable<any> {
        return this.http.post<any>(`${environment.api_url}/advantage/customer/create`, payload);
    }

    getAdvantageOpportunityStartupTypes(): Observable<any> {
        return this.http.get<any>(`${environment.api_url}/advantage/opportunity/startup-types`);
    }

    getAdvantageOpportunitySalespeople(locationId?: number): Observable<any> {
        let params = new HttpParams();
        if (locationId) {
            params = params.set('location_id', locationId.toString());
        }
        return this.http.get<any>(`${environment.api_url}/advantage/opportunity/salespeople`, { params });
    }

    getAdvantageOpportunitySources(locationId?: number): Observable<any> {
        let params = new HttpParams();
        if (locationId) {
            params = params.set('location_id', locationId.toString());
        }
        return this.http.get<any>(`${environment.api_url}/advantage/opportunity/sources`, { params });
    }

    createAdvantageOpportunity(payload: {
        entity_idx: number;
        location_idx?: number;
        startup_type: string;
        salesperson_idx: number;
        source_ids?: number[];
        has_phone?: boolean;
        has_email?: boolean;
    }): Observable<any> {
        return this.http.post<any>(`${environment.api_url}/advantage/opportunity/create`, payload);
    }

    // Get Conversation List
    getConversations(page, filters?) {
        let params = new HttpParams();

        params = params.set('page', page);
        params = params.set('active', 1);

        if(filters) {
            params = params.set('active', filters.archive);
            params = params.set('search', filters.search);
            params = params.set('salesperson', filters.salesperson);
            params = params.set('user', filters.user);
            params = params.set('unread', filters.unread);

            if(filters.opportunity != '') {
                params = params.set('opportunity', filters.opportunity)
            }
        }

        return this.http.get<Array<Object>>(
            `${environment.api_url}/conversations`,
            {
                params: params,
            }
        );
    }

    // Get Conversation
    getConversation(id) {
        return this.http.get<Array<Object>>(
            `${environment.api_url}/conversation/${id}`
        );
    }

    // Get Conversation
    getConversationMessages(id: number, page: number = 1, limit: number = 20) {
        let params = new HttpParams()
            .set('history', '1')
            .set('limit', limit.toString())
            .set('page', page.toString());
     
        if (this.ShowLoading) {
            this.loading.create();
        }
    
        return this.http.get<Array<Object>>(`${environment.api_url}/conversation/${id}/messages`, { params })
            .pipe(
                tap(() => {
                    this.loading.dismiss();
                    this.ShowLoading = false;
                }),
                catchError(error => {
                    this.loading.dismiss();
                    return throwError(error);
                })
            );
    }

searchConversationMessages(
  conversationId: number,
  filters: any,
  page: number = 1,
  limit: number = 20
) {
  let params = new HttpParams()
  .set('history', '1')
    .set('limit', limit.toString())
    .set('page', page.toString());

  if (filters.search) params = params.set('search', filters.search);
  if (filters.recipient) params = params.set('recipient', filters.recipient);
  if (filters.type) params = params.set('type', filters.type);
  if (filters.status) params = params.set('status', filters.status);
  if (filters.dateRange) params = params.set('dateRange', filters.dateRange);
  if (filters.startDate) params = params.set('startDate', filters.startDate);
  if (filters.endDate) params = params.set('endDate', filters.endDate);
  if (filters.sortBy) params = params.set('sortBy', filters.sortBy);

  return this.http.get<any>(
    `${environment.api_url}/conversation/${conversationId}/messages`,
    { params }
  );
}


    setloading():void{
        this.ShowLoading=true;
      }

    // Create Conversation
    createConversation(phone) {
        let data = {
            phone: phone,
        };

        return this.http.post<Object>(
            `${environment.api_url}/conversation/initialize`,
            data
        );
    }
    
    // Set Conversation Assignee
    setConversationAssignee(id, assignee) {
        let data = {
            conversation_id: id,
            assignee: assignee,
        };

        return this.http.post<Object>(
            `${environment.api_url}/conversation/${id}/assign`,
            data
        );
    }

    // Set Conversation Status
    setConversationStatus(id, archiveReason?: string) {
        let data = {
            conversation_id: id,
            archive_reason: archiveReason
        };

        return this.http.post<Object>(
            `${environment.api_url}/conversation/${id}/archive`,
            data
        );
    }

    setConversationUnarchive(id) {
        let data = {
            conversation_id: id,
        };

        return this.http.post<Object>(
            `${environment.api_url}/conversation/${id}/unarchive`,
            data
        );
    }

    setConversationMessages(id) {
        let data = {
            conversation_id: id,
        };

        return this.http.post<Object>(
            `${environment.api_url}/conversation/${id}/messages/read`,
            data
        );
    }

    setConversationWarning(id) {
        let data = {
            conversation_id: id,
        };

        return this.http.post<Object>(
            `${environment.api_url}/conversation/${id}/warning`,
            data
        );
    }

    // Send Conversation Message
    sendConversationMessage(id, phone, body,type:String, attachments = []) {
        let data = {
            conversation_id: id,
            phone: phone,
            body: body,
            type: type,
            attachments: attachments
            
        };

        return this.http.post<Object>(
            `${environment.api_url}/message/create`,
            data
        );
    }

    sendReplyEmailMessage(app_user,user_id, dealer_id, conversation_id, to, cc, from, subject, body, plain_body, type,checked_applicants, attachments,message_id, cidMappings){
        let data ={
            app_user:app_user,
            user_id:user_id,
            dealer_id: dealer_id,
            conversation_id: conversation_id,
            to: to,
            cc:cc,
            from:from,
            subject:subject,
            body:body,
            plain_body:plain_body,
            type:type,
            checked_applicants:checked_applicants,
            attachments: attachments,
            message_id:message_id,
            cid_mappings: cidMappings
        };
        return this.http.post<Object>(
            `${environment.api_url}/mail/reply`,
            data
        );
    }

    //send email
    sendEmailMessage(app_user,user_id, dealer_id, conversation_id, to, cc, from, subject, body, plain_body, type,checked_applicants, attachments, cidMappings){
        let data ={
            app_user:app_user,
            user_id:user_id,
            dealer_id: dealer_id,
            conversation_id: conversation_id,
            to: to,
            cc:cc,
            from:from,
            subject:subject,
            body:body,
            plain_body:plain_body,
            type:type,
            checked_applicants:checked_applicants,
            attachments: attachments,
            cid_mappings: cidMappings
        };
        return this.http.post<Object>(
            `${environment.api_url}/mail/send`,
            data
        );
    }

    // Schedule Conversation Message SMS
    scheduleConversationMessage(id, phone, body, date, attachments = []) {
        let data = {
            conversation_id: id,
            phone: phone,
            body: body,
            attachments: attachments,
            date: date
        };

        return this.http.post<Object>(
            `${environment.api_url}/message/schedule`,
            data
        );
    }

    // Schedule Conversation Message Email
    scheduleConversationEmailMessage(id, phone, body, date, subject, To, From, attachments = [], cidMappings={}) {
        let data = {
            conversation_id: id,
            phone: phone,
            body: body,
            attachments: attachments,
            date: date,
            subject: subject,
            to: To,
            from: From,
            cid_mappings: cidMappings
        };

        return this.http.post<Object>(
            `${environment.api_url}/message/email/schedule`,
            data
        );
    }

    editScheduleConversationMessage(messageId: string, date: string, body: string) {
        let data = {
            message_id: messageId,
            date: date,
            body: body,
        };

        return this.http.post<Object>(
            `${environment.api_url}/message/schedule/update`,
            data
        );
    }

    setConversationMessageUnread(id) {
        let data = {}
        
        return this.http.post<Object>(
            `${environment.api_url}/message/${id}/unread`,
            data
        );
    }
    setConversationMessageread(id) {
            let data = {
                conversation_id: id,
                read:'yes',
            };
    
            return this.http.post<Object>(
                `${environment.api_url}/conversation/${id}/messages/read`,
                data
            );
        }
    deleteScheduledMessage(id){
        let data = { message_id: id };
        return this.http.post<Object>(
            `${environment.api_url}/message/schedule/delete`,
            data
        );
    }

    // Upload Attachment
    uploadAttachment(id, file) {
        const data = new FormData();

        data.append('file', file);

        return this.http.post<Object>(
            `${environment.api_url}/conversation/${id}/attachment`,
            data
        );
    }
    deleteAttachment(id: string, fileUrl: string) {
        let data = { file_url: fileUrl };
        return this.http.post<Object>(`${environment.api_url}/conversation/${id}/attachment/delete`, 
            data
        );
    }

      createActivity(data:any){
        return this.http.post<Object>(`${environment.api_url}/activities`,
            data
        );
      }

      startVoiceCall(payload: {
        to: string;
        from: string;
        conversation_id?: number;
        customer_id?: number;
        dealer_id?: number;
        agent_id?: number;
        contact_name?: string;
      }) {
        return this.http.post<Object>(
          `${environment.api_url}/integrations/twilio/voice/call`,
          payload
        );
      }

      hangupVoiceCall(payload: {
        call_sid: string;
        dealer_id?: number;
        from?: string;
      }) {
        return this.http.post<Object>(
          `${environment.api_url}/integrations/twilio/voice/hangup`,
          payload
        );
      }

      getVoiceToken() {
        return this.http.get<{ token: string; expires_in: number; identity: string }>(
          `${environment.api_url}/integrations/twilio/voice/token`
        );
      }

      getVoiceTransferUsers() {
        return this.http.get<{ users: Array<any> }>(
          `${environment.api_url}/integrations/twilio/voice/transfer/users`
        );
      }

      transferVoiceCall(payload: {
        call_sid: string;
        target_user_id: number;
        dealer_id?: number;
        from?: string;
        token?: string;
      }) {
        return this.http.post<Object>(
          `${environment.api_url}/integrations/twilio/voice/transfer`,
          payload
        );
      }
}

